import { useFormContext, Controller } from 'react-hook-form'
import { Input } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import { FIELD_STUDENTID } from '../constants'
import { validateLimitedString, validateFieldState } from '../validations'

function StudentOrgId({ disabled }) {
  const { control } = useFormContext()

  useEffect(() => {
    CBInputMethod()
  }, [])

  return (
    <Controller
      control={control}
      name={FIELD_STUDENTID}
      disabled={disabled}
      rules={{
        validate: value => validateLimitedString(value),
      }}
      render={({
        field: { onChange, onBlur, value, disabled, name },
        fieldState: { invalid, isDirty, isTouched, error },
      }) => (
        <Input
          label="Student ID"
          name={name}
          value={value}
          onChange={value => onChange(value)}
          onBlur={value => onBlur(value)}
          clearable={false}
          floating={false}
          autoComplete="off"
          maxLength="25"
          disabled={disabled}
          validation={validateFieldState({ invalid, isDirty, isTouched, error, value })}
          validationMsg={error?.message}
        />
      )}
    />
  )
}

export default StudentOrgId
